import { Component} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { Product } from 'src/app/assabil-kernel/models/entities/master-data/product-entity';
import { ProductCategoryLovComponent } from '../../../control-tables/product-category-lov/product-category-lov.component';
import { ProductAnalysisGroup1 } from 'src/app/assabil-kernel/models/entities/control-tables/product-analysis-group1-entity';
import { ProductAnalysisGroup2 } from 'src/app/assabil-kernel/models/entities/control-tables/product-analysis-group2-entity';
import { ProductAnalysisGroup3 } from 'src/app/assabil-kernel/models/entities/control-tables/product-analysis-group3-entity';
import { ProductAnalysisGroup4 } from 'src/app/assabil-kernel/models/entities/control-tables/product-analysis-group4-entity';
import { ProductAnalysisGroup5 } from 'src/app/assabil-kernel/models/entities/control-tables/product-analysis-group5-entity';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { Field } from 'src/app/tools/models/dtos/field';
import { ProductSalesGroupLovComponent } from '../../../control-tables/product-sales-group-lov/product-sales-group-lov.component';
import { ProductLogisticGroupLovComponent } from '../../../control-tables/product-logistic-group-lov/product-logistic-group-lov.component';
import { ProductPage } from 'src/app/assabil-kernel/models/entities/control-tables/product-page';
import { Brand } from 'src/app/assabil-kernel/models/entities/control-tables/brand';


@Component({
    selector: 'product-list',
    templateUrl: './product-list.component.html',
    styleUrls: ['./product-list.component.scss']
})

export class ProductListComponent extends BasePage2<Product>   {

    products            : Product[] = [];
    productCode         : string;
    name                : string;
    productPageCode     : string;
    brandCode           : string;

    includingHold       : boolean;
    salableOnly         : boolean;

    constructor(
        protected masterDataService : MasterDataService,
        protected toastr            : ToastrService,
        protected router            : Router,
        protected baseService       : BaseService,
        protected controlService    : ControlTablesService,
        protected leanUtilsService  : LeanUtilsService, 
        protected location          : Location) {
           super(toastr, router, baseService, leanUtilsService, location);

           this.entityName = 'product';
      }
  
//----------------------------------------------------------------------
ngOnInit(): void {
  super.ngOnInit();

    this.controlService.getList("productPage", this.controlService.getRequest()).then(result => { 
      this.productPages = result;   
    });

    this.controlService.getList("brand", this.controlService.getRequest()).then(result => { 
      this.brands = result;
    })
}
//----------------------------------------------------------------------

//----------------------------------------------------------------------
ngAfterViewInit(): void {
  super.ngAfterViewInit();
    this.setChildFields();
}
//----------------------------------------------------------------------

//----------------------------------------------------------------------
setChildFields(){
/*
  this.baseService.fieldsGet('formField').then(result => {
        this.childFields = result.listFields;
        this.readOnly    = result.readOnly;

        this.childFields.forEach(field => {
            if (field.prop == 'term.termCode') {
              field.modal = TermLovComponent;
            }
        })

  }) 
  */
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
  getRows(): Product[] {
    return this.products;
  }
//----------------------------------------------------------------------


//----------------------------------------------------------------------
loadData() {
  
  this.masterDataService.productsGet(this.productCode, this.name, this.productPageCode, this.brandCode, this.salableOnly, this.includingHold).then(result => {
        this.products = result;
    });
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
new(){
  let product : Product = new Product();
  product.inserted = true;
  product.edit     = true;
  this.selectedRow = product;
}
//----------------------------------------------------------------------

done : boolean = false;
//----------------------------------------------------------------------
  selectRow(product : Product){
    let index : number = this.products.indexOf(product);
    this.masterDataService.productGetByCode(product.productCode).then(result => {
      this.products[index] = result;

      if (this.done) {
        this.selectedRow = result; 
      } else {
        this.initControlTables(result);
      }

      });
  }
//----------------------------------------------------------------------


//----------------------------------------------------------------------
enrichField(field : Field){
    if (field.prop == 'productCategory') {
      field.modal =  ProductCategoryLovComponent;
      field.subProp = 'name';
    }
    
    if (field.prop == 'productSalesGroup') {
      field.modal =  ProductSalesGroupLovComponent;
      field.subProp = 'name';
    }
    if (field.prop == 'productLogisticGroup') {
      field.modal =  ProductLogisticGroupLovComponent;
      field.subProp = 'name';
    }

  }
//----------------------------------------------------------------------
  

//----------------------------------------------------------------------

productAnalysisGroup1s   : ProductAnalysisGroup1[];
productAnalysisGroup2s   : ProductAnalysisGroup2[];
productAnalysisGroup3s   : ProductAnalysisGroup3[];
productAnalysisGroup4s   : ProductAnalysisGroup4[];
productAnalysisGroup5s   : ProductAnalysisGroup5[];
productPages             : ProductPage[];
brands                   : Brand[];
initControlTables(product : Product){
  if (this.done) return;
  this.done = true;
  let request         : BaseRequest = this.controlService.getRequest();
  this.controlService.getList("productAnalysisGroup1", request).then(result => { 
    this.productAnalysisGroup1s = result;
    this.controlService.getList("productAnalysisGroup2", request).then(result => { 
      this.productAnalysisGroup2s = result;
      this.controlService.getList("productAnalysisGroup3", request).then(result => { 
        this.productAnalysisGroup3s = result;
        this.controlService.getList("productAnalysisGroup4", request).then(result => { 
          this.productAnalysisGroup4s = result;
          this.controlService.getList("productAnalysisGroup5", request).then(result => { 
            this.productAnalysisGroup5s = result;
            this.controlService.getList("productPage", request).then(result => { 
              this.productPages = result;
              this.controlService.getList("brand", request).then(result => { 
                this.brands = result;
                this.selectedRow = product; 
              });
            });
          });
        });
      });
    });
  });

}
//----------------------------------------------------------------------
  
}
